import { useEffect } from 'react';


interface Props {
    title: string;
}

export function PageTitle({ title }: Props) {
    useEffect(() => {
        const originalTitle = document.title; // Save the current title
        document.title = title;

        // Restore the original title when the component unmounts
        return () => {
            document.title = originalTitle;
        };
    }, [title]); // Update only when the title changes

    return null;
}
